"use strict";
import { module } from "../app";

module.controller("WorklistCtrl", [
  "$scope",
  "$state",
  "worklistViewModel",
  "$ionicPopover",
  "signalrService",
  "tpConfig",
  function($scope, $state, ViewModel, $ionicPopover, signalrService, tpConfig) {
    $scope.vm = new ViewModel($state.current.state, $scope);

    $scope.$on(tpConfig.events.portalNetworkAvailabilityChanged, (ev, data) =>
      $scope.vm.onNetworkAvailabilityChanged(ev, data)
    );

    // $scope.logout = function() {
    //   $scope.popover.hide();
    //   $scope.$parent.logout();
    // };
    $ionicPopover
      .fromTemplateUrl("views/templates/settingsPopover.html", {
        scope: $scope
      })
      .then(function(popover) {
        $scope.popover = popover;
      });

    $scope.$on("$destroy", function() {
      $scope.vm.destroy();
    });

    if (signalrService.isConnected) {
      $scope.vm.loadFiltersAndWorklistData();
    } /*else {
      $scope.vm.showNetworkAlert({
        isOnlne: signalrService.isConnected
      });
    }*/
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/worklist.js